"use client";
import Text from "@/components/Text";
import { useTranslation } from "@/i18n/client";
import classes from "./index.module.css";
import { Trans } from "react-i18next";
import { Product } from "@/types/enumerations";
import { Campaigns } from "@/types/schemas/campaigns";
import { Commodity, Process } from "@/types/contract";
import { getContractStartDay } from "./helpers";
import { RecontractingVariant } from "@/types/recontractingRequest";
import { useContractState } from "@/hooks/useContractState";
import dayjs from "dayjs";

interface BannerProps {
  product?: Product | null;
  campaign: Campaigns;
  process: Process;
  recontractingVariant?: RecontractingVariant | null;
}

const Banner = ({ product, campaign, process, recontractingVariant }: BannerProps) => {
  const { t } = useTranslation("banner");
  const { t: tCommon } = useTranslation("common");

  const templateCode = campaign.bannerTemplateCode;
  const campaignId = campaign.campaignId;
  const items = templateCode
    ? t(`banners.${templateCode}`, "", { returnObjects: true })
    : t(`banners.${campaignId}`, "", { returnObjects: true });

  const today = new Date();
  const isAfterToday = dayjs(campaign.contractStartDate).isAfter(today, "day");
  const showAdditionalPoint =
    product &&
    (recontractingVariant === RecontractingVariant.CAMPAIGN ||
      recontractingVariant === RecontractingVariant.OPERATORADHOC ||
      recontractingVariant === RecontractingVariant.CUSTOMERADHOC) &&
    isAfterToday;
  const showCode = process === Process.RECONTRACTING;

  const contractState = useContractState();

  return (
    <div>
      <Text variant="subheadline_bold">
        {product ? (
          <Trans i18nKey="bannerTitle" t={t} values={{ value: product.name }} shouldUnescape />
        ) : (
          t("bannerTitleWithoutProduct")
        )}
      </Text>
      <ul className={classes.ul}>
        {Object.values(items as Record<string, string>).map((item, index) => (
          <li key={index}>
            <Text variant="reading_medium">
              <Trans>{item}</Trans>
            </Text>
          </li>
        ))}
        {showAdditionalPoint && (
          <li>
            <Text variant="reading_medium">
              <Trans>{getContractStartDay(campaign, process, product, t, tCommon)}</Trans>
            </Text>
          </li>
        )}
        {showCode && (
          <li>
            <Text variant="reading_medium">
              <Trans
                i18nKey="supplyPoint"
                t={t}
                values={{
                  name: contractState.contract.supplyPoint.commodity === Commodity.Electricity ? "EAN" : "EIC",
                  code: contractState.contract.supplyPoint.code,
                }}
              />
            </Text>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Banner;
